import * as z from "zod";
import { monitoringAnalytics } from "./monitoringAnalytics";
import { mutator } from "./mutator";

// The pair is stored with the ids sorted so it is reviewed once regardless of
// which side was shown first.
export const reviewDuplicatePair = mutator({
  stripKeys: { analytics: Object.keys(monitoringAnalytics.shape) },
  schema: z.object({
    analytics: monitoringAnalytics.optional(),
    workflowAId: z.string(),
    workflowBId: z.string(),
    decision: z.enum(["same", "different"]),
  }),
  resolve: {
    workflowA: { kind: "workflow", from: "workflowAId" },
    workflowB: { kind: "workflow", from: "workflowBId" },
  },
  permissions: [
    { permission: "space:read", scopeId: ({ args }) => args.workflowA.spaceId },
    { permission: "space:read", scopeId: ({ args }) => args.workflowB.spaceId },
  ],
  fn: async ({ tx, ctx, args: { workflowA, workflowB, decision } }) => {
    const [workflowAId, workflowBId] =
      workflowA.id < workflowB.id
        ? [workflowA.id, workflowB.id]
        : [workflowB.id, workflowA.id];
    await tx.mutate.duplicateWorkflowReviews.upsert({
      workflowAId,
      workflowBId,
      decision,
      reviewedByUserId: ctx.userId,
      reviewedAt: Date.now(),
      tenantId: ctx.tenantId,
    });
  },
});
